export default __webpack_public_path__ + "static/media/loader.5269752d.gif";